function registerSlideToRoute(watchTargetRefName, routeDistName, vueCompContext) {
  let mc = new Hammer(vueCompContext.$refs[watchTargetRefName])
  mc.get('pan').set({ direction: Hammer.DIRECTION_ALL })
  mc.on("pandown", function me(ev) {
    mc.off('pandown', me)
    vueCompContext.$router.push({ name: routeDistName })
  })
}

export default {
  registerSlideToRoute,
}
